import "slick-carousel";

import "slick-carousel/slick/slick.css";

$(document).ready(function() {
  // show/hide filters on mobile
  $("#filtersBtn").on("click", function() {
    $("#filters").slideToggle();
    $("#filtersShow, #filtersHide").toggle();
  });

  // Swap listings in place so town filter / pagination does not jump to top
  function loadAttractionList(url, push) {
    if (!$("#attractionListings").length) {
      window.location = url;
      return;
    }
    $.get(url, function(html) {
      var $html = $(html);
      $("#attractionListings").html($html.find("#attractionListings").html());
      $("#townFilter").html($html.find("#townFilter").html());
      if (typeof window.handleLazyImages === "function") {
        window.handleLazyImages();
      }
      if (push) {
        history.pushState({ attractionsFilter: true }, "", url);
      }
    });
  }

  $(document).on("click", "#townFilter a", function(e) {
    e.preventDefault();
    loadAttractionList(this.href, true);
  });

  $(document).on("click", "#attractionListings .pagination a", function(e) {
    e.preventDefault();
    loadAttractionList(this.href, true);
  });

  $(window).on("popstate", function() {
    if ($("#attractionListings").length) {
      loadAttractionList(window.location.href, false);
    }
  });

  $("#attractionsCarousel").slick({
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    rows: 0,
    prevArrow: $("#attractionsPrev"),
    nextArrow: $("#attractionsNext"),
    appendDots: $("#attractionsDots"),
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      }
    ]
  });
});
